// 1️⃣ General accordion setup for all pages
window.onload = function() {
    if (window.$ && afConfig && afConfig.template) {
        if (afConfig.template.includes("product") || afConfig.template.includes("page") || afConfig.template.includes("collection")) {
            
            // Generic accordion handling for all modules
            $(".af-accordion").find("h4").click(function(){
                $(this).next().slideToggle(300);
                $(this).toggleClass('open');
                $(".af-accordion aside").not($(this).next()).slideUp(300);
                $(".af-accordion h4").not($(this)).removeClass('open');
            });

            // Booking module accordion setup
            $(".af-accordion-v2 .accordion-title").each(function(i) {
                $(this).attr({
                    "tabindex": "0",
                    "role": "button",
                    "aria-expanded": "false",
                    "aria-controls": "accordion-panel-" + i
                });
                $(this).next("aside").attr({
                    "id": "accordion-panel-" + i,
                    "role": "region",
                    "aria-hidden": "true"
                });
            });

            $(".af-accordion-v2").find(".accordion-title").on("click keydown", function(e) {
                if (e.type === "click" || e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    let $this = $(this);
                    let $panel = $this.next("aside");
                    $panel.slideToggle(300);
                    $this.toggleClass("open");
                    let isOpen = $this.hasClass("open");
                    $this.attr("aria-expanded", isOpen);
                    $panel.attr("aria-hidden", !isOpen);
                    $(".af-accordion-v2 aside").not($panel).slideUp(300).attr("aria-hidden", "true");
                    $(".af-accordion-v2 .accordion-title").not($this).removeClass("open").attr("aria-expanded", "false");
                }
            });

            // ---- Open booking accordion on page load if ?open=book ----
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get("open") === "book") {
                const accordionContainer = document.querySelector(".af-booking-accordion");
                if (accordionContainer) {
                    accordionContainer.scrollIntoView({ behavior: "smooth", block: "start" });
                    setTimeout(() => {
                        const firstAccordionHeader = accordionContainer.querySelector(".af-accordion-v2 .accordion-title");
                        if (firstAccordionHeader && !firstAccordionHeader.classList.contains("open")) {
                            firstAccordionHeader.click();
                        }
                    }, 100);
                } else if (typeof bookingButton !== "undefined" && typeof bookingButton.start === "function") {
                    bookingButton.start();
                }
            }
        }
    }
};

// 2️⃣ Intercept clicks on any link with ?open=book
document.addEventListener("click", function(e) {
    const trigger = e.target.closest('a[href*="?open=book"]');
    if (!trigger) return;

    // Check if the page has a booking accordion
    const accordionContainer = document.querySelector(".af-booking-accordion");
    if (accordionContainer) {
        e.preventDefault(); // prevent default link behaviour
        accordionContainer.scrollIntoView({ behavior: "smooth", block: "start" });
        setTimeout(() => {
            const firstAccordionHeader = accordionContainer.querySelector(".af-accordion-v2 .accordion-title");
            if (firstAccordionHeader && !firstAccordionHeader.classList.contains("open")) {
                firstAccordionHeader.click();
            }
        }, 100);
    } else {
        // Assume modal: prevent page reload and open modal
        e.preventDefault();
        if (typeof bookingButton !== "undefined" && typeof bookingButton.start === "function") {
            bookingButton.start();
        }
    }
});